import { OptionDetail } from '../../types/OptionChainType';

export const filterMinimumBid = (minimumBid: number) => (option: OptionDetail): boolean => {
    return option.last_quote.bid > minimumBid;
};
